/* eslint-disable */
import { parsePhoneNumberFromString } from 'libphonenumber-js'
window.parsePhone = Vue.prototype.parsePhone = parsePhoneNumberFromString
window.log = Vue.prototype.log = console.log.bind(console)
Vue.prototype.alert = (msg) => window.alert(msg)
window.vueset = Vue.prototype.vueset = Vue.set
window.setLocalStorage = Vue.prototype.setLocalStorage = (key,value) => localStorage.setItem(key, value)
window.getLocalStorage = Vue.prototype.getLocalStorage = (key) => {
  const value = localStorage.getItem(key)
  if (value === 'undefined' || value === 'null') return null
  return value
}

window.bind_key = Vue.prototype.bind_key = (target, key, path) => {
  const ref = firebase.database().ref((localStorage.ENV || 'v2') + '/' +  path)
  return ref.on('value', snapshot => {
    Vue.set(target, key, snapshot.val())
  })
}
window.update_query = Vue.prototype.update_query = query => vm.$router.push({ query: vm.$route.query.addObj(query).filter((v, k) => v) })
window.update_filter = Vue.prototype.update_filter = (k, v) => {
  const query = Sugar.Object.clone(vm.$route.query)
  query[k] = query[k] ? query[k].split('|') : []
  v.split('|').map(v => query[k] = query[k].includes(v) ? query[k].remove(v) : query[k].add(v))
  query[k] = query[k].join('|')

  return update_query(query)
}
window.type = Vue.prototype.type = x => Object.prototype.toString.call(x).slice(8, -1).toLowerCase()
window.size = Vue.prototype.size = () => {
  let size = ''
  if (window.innerWidth > 1500) size += 'desktop4K '
  if (window.innerWidth > 1200) size += 'desktop '
  if (window.innerWidth > 900) size += 'laptop '
  if (window.innerWidth > 600) size += 'tablet '
  return size += 'mobile'
}
window.browser = Vue.prototype.browser = () => {
  const ua = navigator.userAgent
  if (/MSIE/.test(ua) || /Trident/.test(ua)) return 'ie'
  if (/Edge/.test(ua)) return 'edge'
  if (/Firefox/.test(ua)) return 'firefox'
  if (/Opera/.test(ua)) return 'opera'
  if (/Chrome/.test(ua)) return 'chrome'
  if (/Safari/.test(ua)) return 'safari'
  return 'unknown'
}
window.set = Vue.prototype.set = (path, v) =>
  path
  .split('.')
  .reduce((acc, p) => acc.child(p), firebase.database().ref('/' + (localStorage.ENV || 'v2')))
  .set(v)

window.firebase_delete = Vue.prototype.firebase_delete = (path) =>
  path
  .split('.')
  .reduce((acc, p) => acc.child(p), firebase.database().ref('/' + (localStorage.ENV || 'v2')))
  .remove()
// Je veux pouvoir parser:
// [0612345678, '+33612345678', '06-12-34-56-78', 3312345678, '+34612345678', '+353 1 437 0969']
const parse_phone_prefix = (str) => {
  if (str.length === 10 && str[0] === '0') return '33' + str.slice(1)
  if (str.length === 9) return '33' + str.slice(1)
  return str
}
window.format_phone = Vue.prototype.format_phone = (val) => {
  if (!val) return
  const clean_string = parse_phone_prefix(val.toString().replace(/\D/g,''))
  return '+' + clean_string.slice(0,-8) + ' ' + clean_string.slice(-8).replace(/(\d{2})/g, '$1 ').trim()
}

window.format = Vue.prototype.format = (specifier) => {
  if (specifier === '%') return (val) => parseInt(val * 100) + '%'
  return v => v
}

window.parse_duration = Vue.prototype.parse_duration = (duration, pad = false) => {
  const hours = (duration / 60)
  let rhours = Math.floor(hours)
  const minutes = (hours - rhours) * 60;
  let rminutes = Math.round(minutes);
  if (pad && ('' + rhours).length === 1) rhours = '0' + rhours
  if (pad && ('' + rminutes).length === 1) rminutes = '0' + rminutes
  if (!pad && !rhours) return rminutes + 'm'
  if (!pad && !rminutes) return rhours + 'h'
  return rhours + 'h' + rminutes + 'm'
}
